import React, { useState, useEffect } from "react";
import axios from "axios";
import "../CSS/GalleryEdit3.css";

const GalleryEdit3 = () => {
  const [galleryData, setGalleryData] = useState([]);

  useEffect(() => {
    fetchGalleryData();
  }, []);

  const fetchGalleryData = async () => {
    try {
      const response = await axios.get("https://us-central1-janushreebeautyparlour.cloudfunctions.net/api/getGalleryContent1");
      const data = response.data ? Object.values(response.data) : [];
      setGalleryData(data);
    } catch (error) {
      console.error("Error fetching gallery data:", error);
    }
  };

  return (
    <div className="canvas" style={{backgroundColor:"black"}}>
     
      {galleryData.length > 0 && galleryData.map((gallery, index) => (
        <div key={index} className="cube-wrapper">
        <h1 className="text-center blackthemegradient">{gallery.title2}</h1>
        <p>{gallery.description2}</p>
          <div className="cube">
           

            {/* Check if gallery.subtitle exists and has sufficient elements */}
            {gallery.subtitles && gallery.subtitles.length > 0 && (
              <>
                <div className="side front" style={{ backgroundImage: `url(${gallery.subtitles[0]?.subimage})` }} />
                <div className="side back" style={{ backgroundImage: `url(${gallery.subtitles[1]?.subimage})` }} />
                <div className="side left" style={{ backgroundImage: `url(${gallery.subtitles[2]?.subimage})` }} />
                <div className="side right" style={{ backgroundImage: `url(${gallery.subtitles[3]?.subimage})` }} />
                <div className="side top" style={{ backgroundImage: `url(${gallery.subtitles[4]?.subimage})` }} />
                <div className="side bottom" style={{ backgroundImage: `url(${gallery.subtitles[5]?.subimage})` }} />
              </>
            )}
          </div>
        </div>
      ))}
      <button className="toggle-button">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
          className="play-icon"
          style={{ display: "none" }}
        >
          <polygon points="5 3 19 12 5 21 5 3" />
        </svg>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
          className="pause-icon"
        >
          <rect x={6} y={4} width={4} height={16} />
          <rect x={14} y={4} width={4} height={16} />
        </svg>
      </button>
    </div>
  );
};

export default GalleryEdit3;
